@if (trustProfile) {
  <div class="card-body">
    <div class="row-container">
      <div class="left">
        <div class="form-group">
          <label class="title mb-1">Name</label>
          <div class="property">
            <div appCopy>{{ trustProfile.name }}</div>
          </div>
        </div>

        <div class="row-container">
          <div class="left">
            <div class="form-group mb-0">
              <label class="title mb-1">ABN</label>
              <div class="property">
                <div appCopy>{{ trustProfile.abn | abn }}</div>
              </div>
            </div>
          </div>

          <div class="right">
            <div class="form-group">
              <label class="title mb-1">Status</label>
              <div class="property">
                <div appCopy>{{ trustProfile.status | trustStatus }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="right">
        <div class="row-container">
          <div class="left">
            <div class="form-group">
              <label class="title mb-1">Commencement date</label>
              <div class="property">
                <div appCopy>{{ trustProfile.dateOfEstablishment | dateFormat }}</div>
              </div>
            </div>
          </div>

          <div class="right">
            <div class="form-group">
              <label class="title mb-1">Jurisdiction</label>
              <div class="property">
                <div appCopy>{{ jurisdiction }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="row-container">
          <div class="right">
            <div class="form-group">
              <label class="title mb-1 d-block">Trust Type</label>
              <div class="property d-inline">
                <div appCopy>{{ trustProfile.trustSubType | trustSubType }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="horizontal-divider"></div>

    <div class="row-container">
      <div class="left">
        <div class="form-group">
          <label class="title mb-1">Address</label>
          <div class="property">
            <div appCopy>{{ trustProfile.registeredAddress.normalizedFullAddress | defaultValue }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="horizontal-divider"></div>

    @for (trustee of trustProfile.trustees; track trustee.relationshipId) {
      <div class="row-container trusty-element">
        <div class="left">
          <div class="form-group">
            <label class="title mb-1">Trustee Name</label>
            <div class="property">
              <div
                appCopy>{{ trustee.individualDataOverride?.fullNameLabel ?? trustee.entityDataOverride?.name ?? '-' }}
              </div>
            </div>
          </div>
        </div>

        <div class="right">
          <div class="form-group">
            <label class="title mb-1">Address</label>
            <div class="property">
              <div
                appCopy>{{ trustee.individualDataOverride?.address?.normalizedFullAddress ?? trustee.entityDataOverride?.registeredAddress?.normalizedFullAddress | defaultValue }}
              </div>
            </div>
          </div>
        </div>
      </div>
    }

    @if (trustProfile.trustees.length) {
      <div class="horizontal-divider"></div>
    }

    <div class="row-container">
      <div class="left">
        <div class="form-group">
          <label class="title mb-1">Dates of variation</label>
          <div class="property">
            <div appCopy>{{ variationDates }}</div>
          </div>
        </div>
      </div>

      <div class="right">
        <div class="form-group">
          <label class="title mb-1">Vesting Date</label>
          <div class="property">
            <div appCopy>{{ trustProfile.vestingDate | dateFormat }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="horizontal-divider"></div>

    <div class="row-container">
      <div class="left">
        <div class="form-group">
          <label class="title mb-1">Partner</label>
          <div class="property">
            <div appCopy>{{ trustProfile.partnerManager?.fullName | defaultValue }}</div>
          </div>
        </div>
      </div>

      <div class="right">
        <div class="form-group">
          <label class="title mb-1">Account Manager</label>
          <div class="property">
            <div appCopy>{{ trustProfile.accountManager?.fullName | defaultValue }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="horizontal-divider"></div>

    <div class="row-container">
      <div class="left">
        <div class="form-group">
          <label class="title mb-1">Reference Number</label>
          <div class="property">
            <div appCopy>{{ trustProfile.referenceNumber | defaultValue }}</div>
          </div>
        </div>
      </div>

      <div class="right">
        <div class="form-group">
          <label class="title mb-1">Family group</label>
          <div class="property">
            <div appCopy>{{ trustProfile.familyGroup | defaultValue }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="horizontal-divider"></div>
    <div class="row-container">
      <div class="left">
        <div class="form-group">
          <label class="title mb-1">Signing Contact</label>
          <div class="property mb-1">
            {{ trustProfile.signingContact?.firstName }} {{ trustProfile.signingContact?.lastName }}
          </div>

          <div class="contact form-group mb-1">
            <span class="contact-icon mr-1">&#64;</span>
            <div class="property">
              <div appCopy>{{ trustProfile.signingContact?.email }}</div>
            </div>
          </div>

          <div class="contact form-group align-items-center">
            <i class="icon ic-phone-16 mr-1"></i>
            <div class="property">
              <div appCopy>{{ trustProfile.signingContact?.phone }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}
